import {
  ActivitySettings,
  ActivityType,
  DiagramGeneralSettings,
  FlowlineSettings,
  RichTextSettings
} from '../diagram-type-styles.model';
import {AGENT_INSTRUCTION} from '../../../shared/constants/diagram-subtypes.constants';
import {UPNBaseConfig} from './diagram-upn-base-config';
import {MAPS_TYPES_ENUM as MAP_TYPES} from '../../../editor-interface/shared/models/map.model';

export class AgentInstructionConfig extends UPNBaseConfig {
  generalSettings(): DiagramGeneralSettings {
    return {
      ...super.generalSettings(),
      canGenerateRequirements: false,
      tagColor: '#6B4C93',
      allowedDrilldownSubtypes: [MAP_TYPES.AGENT_INSTRUCTION, MAP_TYPES.INTERACTION_FLOW],
      disableSubtypeChange: true
    };
  }

  readonly activityShape = {w: 200, h: 180};

  activitySettings(x?: number, y?: number): ActivitySettings {
    const baseSettings = super.activitySettings(x, y);
    const defaultResources = this.getDefaultResources([
      AGENT_INSTRUCTION.RESOURCE_ACTIVITY_TYPES.AI_AGENT
    ]);

    return {
      ...baseSettings,
      text: AGENT_INSTRUCTION.ACTIVITY_TEXT,
      createActivityWithFlowline: true,
      defaultResources
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    const baseSettings = super.flowlineSettings(x, y, id);
    const defaultFlowlineShape = {w: 140, h: 0};

    return {
      ...baseSettings,
      defaultGeoY: 60,
      defaultFlowlineShape,
      config: {
        srcType: 'none',
        tgtType: 'activity',
        waypoints: null,
        text: AGENT_INSTRUCTION.FLOWLINE_TEXT,
        srcPosition: {
          x: x - 140,
          y: y + 90
        },
        tgtPosition: {
          x: x + 140,
          y: y
        },
        position: {
          connectionPoints: {
            entryX: 0,
            entryY: 0.5
          },
          offset: {x: 0, y: 0},
          x: 0,
          y: 60
        },
        srcId: null,
        tgtId: Number(id)
      },
      template: '<div class="agent-flowline-content">{{content}}</div>'
    };
  }

  get richTextSettings(): RichTextSettings {
    const defaultTextShape = {w: 340, h: 140};
    const baseSettings = super.richTextSettings;

    return {
      ...baseSettings,
      defaultTextShape,
      template:
        '<input type="hidden" name="number" value="{{number}}"><div class="agent-text-shape-content">{{content}}</div>',
      preparePayload: ({x, y, number, style, position}) => ({
        number,
        text: AGENT_INSTRUCTION.RICH_TEXT,
        position: this.getPosition(defaultTextShape, x, y, position),
        customStyle: true,
        style: {
          ...style,
          borderColor: '#D10000',
          fontColor: '#000000'
        }
      })
    };
  }

  readonly activityTypes: ActivityType[] = [
    {
      tooltip: 'ASIDE_L.AGENT_INSTRUCTION_TOOLTIP',
      icon: 'agent_instruction',
      settings: (x?: number, y?: number) => this.activitySettings(x, y)
    },
    {
      tooltip: 'ASIDE_L.AGENT_ACTION_TOOLTIP',
      icon: 'agent_action',
      settings: (x?: number, y?: number) => {
        return {
          ...this.activitySettings(x, y),
          text: AGENT_INSTRUCTION.ACTIVITY_TEXT_ACTION,
          defaultResources: this.getDefaultResources([
            AGENT_INSTRUCTION.RESOURCE_ACTIVITY_TYPES.ACTION
          ]),
          customStyle: true,
          style: {
            borderColor: '#c89c18'
          }
        };
      }
    },
    {
      tooltip: 'ASIDE_L.AGENT_PROMPT_TOOLTIP',
      icon: 'agent_prompt',
      settings: (x?: number, y?: number) => {
        return {
          ...this.activitySettings(x, y),
          text: AGENT_INSTRUCTION.ACTIVITY_TEXT_PROMPT,
          defaultResources: this.getDefaultResources([
            AGENT_INSTRUCTION.RESOURCE_ACTIVITY_TYPES.PROMPT_TEMPLATE
          ]),
          customStyle: true,
          style: {
            borderColor: '#c89c18'
          }
        };
      }
    }
  ];
}
